// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__3yndN","header":"About_header__2O68u","info":"About_info__14iLj","issue":"About_issue__3w44T","saverImage":"About_saverImage__1CVM1"};